/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Vue, Prop} from 'vue-property-decorator'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'
import MessageBox from '@/components/shared/MessageBox'
import Multiselect from 'vue-multiselect'
import YaraServiceMixin from '@/services/YaraServiceMixin'
import {RuleSetVO} from '@/valueObjects/RuleSetVO'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import YaraService from '@/services/YaraService'
import {AnalysisService} from '@/services/AnalysisService'
import {Mutation} from 'vuex-class'
import ReportValidator from '@/utils/validators/ReportValidator'
import {ERROR_MESSAGE_TYPE, SUCCESS_MESSAGE_TYPE} from '@/utils/constants'

@Component({
    mixins: [AnalysisServiceMixin, YaraServiceMixin],
    components: {
        MessageBox,
        Multiselect,
    },
})

export default class AnalysisRescan extends Vue {
    @Prop()
    private analysis: AnalysisVO

    private message = ''
    private messageType = ERROR_MESSAGE_TYPE
    private rulesets: RuleSetVO[] = []
    private selectedRulesets: RuleSetVO[] = []
    private yaraService: YaraService
    private analysisService: AnalysisService  // redeclared variable to avoid warnings in Webstorm
    private isVirusTotalSelected: boolean = false
    private isPFAVSelected: boolean = false
    @Mutation('setStoreMessage') private setStoreMessage: any

    public async mounted(): Promise<void> {
        try {
            this.$emit('displayHeader', false)
            this.message = ''
            this.rulesets = await this.yaraService.getRuleSets()

        } catch (e) {
            this.message = `The loading of Yara rules failed. ${e.errorMessage}`
        }
    }

    public beforeDestroy() {
        this.$emit('displayHeader', true)
    }

    public async submit(): Promise<void> {
         this.clearMessage()

         const analysisParameters = {
             ruleset_subset: this.selectedRulesets.map((ruleSetVO: RuleSetVO) => {
                 return ruleSetVO.name
             }).join(),
         }
         try {
             const analysisResult = await this.analysisService.updateAnalysis(this.analysis.id,
                 this.isVirusTotalSelected,this.isPFAVSelected, true, analysisParameters)
             this.message = 'Analysis successfully posted'
             this.messageType = SUCCESS_MESSAGE_TYPE
             this.$emit('refreshAnalysis')
             this.redirectToAnalysisInProgressPage(analysisResult)
         } catch (e) {
             this.messageType = ERROR_MESSAGE_TYPE
             this.message = e.errorMessage
         }
    }

    private redirectToAnalysisInProgressPage(analysisResult: {[key: string]: any}) {
        if (analysisResult.hasOwnProperty('id')) {
            const analysisResultId = analysisResult.id.toString()

            /* NewAnalysis component is a child of Home view
               Analysis-Summary is a child of Analysis view
               Hence message sent from NewAnalysis to Analysis-Summary cannot be sent using a $emit so we use the store.
            */
            this.setStoreMessage('Yara analysis will start shortly.')

            this.$router.push({name: 'analysis-summary', params: { analysisId: analysisResultId}})
        } else {
            throw new Error('Error in new analysis processing: unexpected content answer from server')}
    }

    private clearMessage() {
        this.message = ''
    }

    private hasInformation(field: string): boolean {
        return ReportValidator.hasStaticField(this.analysis, field)
    }

    private MultiselectTextOnselectedOverflow(count: number): string {
        return `and ${count} more`
    }

}
